import { splitWithFormat, getSeparator } from 'utils/date'
import DateFormatError from 'error/dateFormatError'

const CENTURY_20TH_PREFIX = '19'
const CENTURY_21TH_PREFIX = '20'
const YEAR_FORMAT = 'yyyy'

/* 
  the function add the first part of the year if not provided
  eg `69` -> `1969`; `00` -> `2000`; `03` -> `2003`
*/
export function getAutocompletedYear(currentDatePart: string): string {
  const CURRENT_YEAR = new Date().getFullYear()
  const LAST_TWO_DIGITS_OF_CURRENT_YEAR = CURRENT_YEAR % 100

  const twoFirstCharsOfYearAsNumber = Number(
    currentDatePart[0] + currentDatePart[1]
  )

  if (
    !Number.isNaN(twoFirstCharsOfYearAsNumber) &&
    Number.isNaN(Number(currentDatePart[3])) &&
    Number.isNaN(Number(currentDatePart[4]))
  ) {
    const yearCenturyPrefix =
      twoFirstCharsOfYearAsNumber > LAST_TWO_DIGITS_OF_CURRENT_YEAR
        ? CENTURY_20TH_PREFIX
        : CENTURY_21TH_PREFIX
    const yearLastTwoDigitsPart = currentDatePart[0] + currentDatePart[1]

    return yearCenturyPrefix + yearLastTwoDigitsPart
  }

  return currentDatePart
}

export function convertFormat(
  date: string,
  fromFormat: string,
  toFormat: string
) {
  const dateParts = splitWithFormat(date, fromFormat)

  if (!dateParts) {
    throw new DateFormatError('Could not parse date parts', date, fromFormat)
  }

  const newSeparator = getSeparator(toFormat)

  if (!newSeparator) {
    throw new DateFormatError(
      'Could not find valid separator in format',
      date,
      fromFormat
    )
  }

  const formattedDate = toFormat
    .split(newSeparator)
    .reduce((newFormat, currentPart) => {
      const currentDatePart = dateParts.splitted[currentPart]
      const isYearDatePart = currentPart === YEAR_FORMAT

      if (!currentDatePart) {
        return newFormat
      }

      if (!newFormat) {
        return isYearDatePart
          ? getAutocompletedYear(currentDatePart)
          : currentDatePart
      }

      return `${newFormat}${newSeparator}${
        isYearDatePart ? getAutocompletedYear(currentDatePart) : currentDatePart
      }`
    }, '')

  return formattedDate
}
